// A manual's file: into this vessel's crew-docs/manuals folder (the database checks the same folder, sql/manuals.sql), path back.
// The bucket is PRIVATE: the stored value (file_url) is only the file's identifier - its PATH for new uploads (sql/fixes-1.sql),
// a full link for older ones - and a page opens it through a 10-minute signed link (openManualFile), never the stored value itself.
import { supabase } from './supabase'
import { filePath } from './filePaths'
import { uploadProblem } from './uploadTypes'
import { signManualDirect, signUrl } from './fileAccess'

export const MANUAL_ACCEPT = '.pdf,.doc,.docx'
export const MAX_MB = 50
export async function uploadManualFile(clientId, file) {
  if (!file) throw new Error('Choose a file')
  if (file.size > MAX_MB * 1024 * 1024) throw new Error('That file is over ' + MAX_MB + ' MB')
  if (!/\.(pdf|docx?)$/i.test(file.name)) throw new Error('A manual must be a PDF or a Word file')
  const bad = uploadProblem(file)   // the type the browser gives must be one the bucket takes (src/lib/uploadTypes.js)
  if (bad) throw new Error(bad)
  const path = filePath('manuals', clientId, file.name)
  const { error } = await supabase.storage.from('crew-docs').upload(path, file)
  if (error) throw error
  return { url: path, name: file.name }
}
// "Gen_Manual-v3.pdf" -> "Gen Manual-v3"
export const titleFromFile = name => String(name || '').replace(/\.[^.]+$/, '').replace(/_+/g, ' ').trim() || 'Manual'

// a stored link -> a signed link that opens (createSignedUrl for the manuals folder, else the server's check: older uploads);
// "#page=12" is kept. offline: the copy in the offline pack (src/lib/manualOffline.js) when there is one. null = cannot open.
let offlineCopy = null   // set by manualOffline.js (no import cycle)
export const setOfflineCopy = fn => { offlineCopy = fn }
export async function signedManualUrl(url, manualId) {
  const [u, hash] = String(url || '').split('#')
  if (!u) return null
  const s = (await signManualDirect(u)) || (await signUrl(u).catch(() => null))
  if (s) return s + (hash ? '#' + hash : '')
  const local = offlineCopy && manualId ? await offlineCopy(manualId, u).catch(() => null) : null
  return local ? local + (hash ? '#' + hash : '') : null
}
// open it in a new tab: the tab is opened at once (pop-up blockers allow only that), then sent to the signed link
export async function openManualFile(url, manualId) {
  const open = (typeof window !== 'undefined' && window.__hcOpen) || ((...a) => window.open(...a))
  const w = open('about:blank', '_blank')
  const s = await signedManualUrl(url, manualId)
  if (s) { if (w) w.location.href = s; else window.location.href = s; return true }
  try { if (w) w.close() } catch (e) {}
  window.alert(typeof navigator !== 'undefined' && navigator.onLine === false ? 'You are offline and this manual is not in the offline pack.' : 'This file could not be opened - you may not have access to it, or it is no longer in storage.')
  return false
}
